import { useState, useEffect } from 'react';

const DS_API = 'https://staging-api.dopscale.com';
const TOKEN_KEY = 'adintel_token';
const USER_KEY = 'adintel_user';

export default function AcceptInvitation() {
  const [token, setToken] = useState(null);
  const [invitation, setInvitation] = useState(null);
  const [loadState, setLoadState] = useState('loading'); // loading|ok|error
  const [error, setError] = useState(null);

  // form
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    // Token vem do query string do hash (#/aceitar-convite?token=X)
    const hashPart = window.location.hash;
    const q = hashPart.includes('?') ? hashPart.split('?')[1] : '';
    const params = new URLSearchParams(q);
    const t = params.get('token');
    if (!t) { setLoadState('error'); setError('Token nao fornecido no link.'); return; }
    setToken(t);
    fetch(`${DS_API}/invitations/${t}`)
      .then(async r => {
        const d = await r.json();
        if (!r.ok) throw new Error(d?.error || `HTTP ${r.status}`);
        setInvitation(d?.data);
        setLoadState('ok');
      })
      .catch(err => { setLoadState('error'); setError(String(err.message || err)); });
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (password !== password2) { setError('Senhas nao conferem'); return; }
    if (password.length < 8) { setError('Senha precisa de pelo menos 8 caracteres'); return; }
    setSubmitting(true);
    try {
      const r = await fetch(`${DS_API}/invitations/${token}/accept`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name.trim(), phone: phone.trim() || undefined, password }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d?.error || `HTTP ${r.status}`);
      // Loga direto: salva token+user e redireciona
      localStorage.setItem(TOKEN_KEY, d.data.token);
      localStorage.setItem(USER_KEY, JSON.stringify(d.data.user));
      window.location.hash = 'dashboard';
      window.location.reload();
    } catch (err) {
      setError(String(err.message || err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>AdIntel</div>
        {loadState === 'loading' && <div style={s.dim}>Validando convite...</div>}
        {loadState === 'error' && (
          <div>
            <div style={s.errTitle}>Convite invalido</div>
            <div style={s.errText}>{error}</div>
            <div style={{ marginTop: 20 }}>
              <a href="#login" style={s.link}>Ir para login</a>
            </div>
          </div>
        )}
        {loadState === 'ok' && invitation && (
          <>
            <div style={s.subtitle}>Voce foi convidado</div>
            <div style={s.title}>Criar sua conta</div>
            <div style={s.meta}>
              Email: <strong style={{ color: 'var(--text)' }}>{invitation.email}</strong>
              {invitation.inviter_name && <><br />Convidado por: <strong style={{ color: 'var(--text)' }}>{invitation.inviter_name}</strong></>}
              {invitation.org_name && <><br />Organizacao: <strong style={{ color: 'var(--text)' }}>{invitation.org_name}</strong></>}
            </div>
            <form onSubmit={submit} style={s.form}>
              <div>
                <label style={s.label}>Nome completo</label>
                <input type="text" value={name} onChange={e => setName(e.target.value)} required style={s.input} autoFocus />
              </div>
              <div>
                <label style={s.label}>Telefone (opcional)</label>
                <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="55 62 9XXXX XXXX" style={s.input} />
              </div>
              <div>
                <label style={s.label}>Senha (min 8 caracteres)</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={8} style={s.input} />
              </div>
              <div>
                <label style={s.label}>Confirmar senha</label>
                <input type="password" value={password2} onChange={e => setPassword2(e.target.value)} required minLength={8} style={s.input} />
              </div>
              {error && <div style={s.errBox}>{error}</div>}
              <button type="submit" disabled={submitting} style={{ ...s.btn, opacity: submitting ? 0.5 : 1 }}>
                {submitting ? 'Criando conta...' : 'Criar conta e entrar'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  card: { width: '100%', maxWidth: 440, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, padding: 36 },
  logo: { fontSize: 22, fontWeight: 700, color: 'var(--accent)', marginBottom: 32 },
  subtitle: { fontSize: 11, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 4 },
  title: { fontSize: 22, fontWeight: 700, color: 'var(--text)', marginBottom: 16 },
  meta: { fontSize: 13, color: 'var(--text2)', lineHeight: 1.6, marginBottom: 24, padding: '12px 14px', background: 'var(--surface2)', borderRadius: 6 },
  form: { display: 'flex', flexDirection: 'column', gap: 14 },
  label: { fontSize: 11, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.4, fontWeight: 600, marginBottom: 4, display: 'block' },
  input: { width: '100%', padding: '10px 14px', border: '1px solid var(--border)', borderRadius: 6, background: 'var(--surface2)', color: 'var(--text)', fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' },
  btn: { padding: '12px 20px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 6, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', marginTop: 8 },
  errBox: { padding: '10px 14px', background: 'rgba(239,68,68,0.10)', color: 'var(--accent-r)', borderRadius: 6, fontSize: 12 },
  errTitle: { fontSize: 16, fontWeight: 600, color: 'var(--accent-r)', marginBottom: 8 },
  errText: { fontSize: 13, color: 'var(--text2)' },
  dim: { fontSize: 13, color: 'var(--text3)', padding: 24, textAlign: 'center' },
  link: { color: 'var(--accent)', fontSize: 13, textDecoration: 'none' },
};
